import PopupBodyChart from "../../../../components/map/popup/PopupBodyChart";
import PopupFooter from "../../../../components/map/popup/PopupFooter";
import PopupHeader from "../../../../components/map/popup/PopupHeader";
import APP from "../../../config";
import data from "../data";
import geo from "../geo";
import meta from "../meta";

/**
 * Share of sittings statistics.
 * 
 * @author Adam Janosik, Kristyna Zaklova
 */

const popup = {
    header: {
        component: PopupHeader,
        props: {
            data: data
        }
    },
    body: {
        component: PopupBodyChart,
        props: {
            data: data,
            stats: [
                {
                    title: "Srovnání dle průměrného počtu hlasování na jednom zasedání za volební období 2020-2024 (s výjimkou Prahy)",
                    content: () => {
                        return (
                            <>
                                <p>Za uplynulé volební období se průměrný počet hlasování v&nbsp;rámci jednoho zasedání pohyboval mezi <span className="emp"><strong>25</strong></span> a&nbsp;<span className="emp"><strong>104</strong></span> hlasováními. Nejvyšší počet byl v&nbsp;<span className="emp"><strong>Moravskoslezském kraji</strong></span>, nejnižší pak v&nbsp;<span className="emp"><strong>Pardubickém kraji</strong></span>.</p>
                            </>
                        )
                    },
                    chart: {
                        type: "bar",
                        config: {
                            geo: geo,
                            data: data,
                            categories: meta.pocetHlasovaniNaZasedani.values,
                            getValue: meta.pocetHlasovaniNaZasedani.getValue,
                            formatValue: meta.pocetHlasovaniNaZasedani.formatValue
                        }
                    }
                }
            ]
        }
    },
    footer: {
        component: PopupFooter,
        props: {
            data: data,
            settings: {
                left: {
                    title: {
                        label: "Zdroj:",
                        icon: "pi pi-fw pi-globe"
                    },
                    links: [
                        {
                            label: "Datové sady",
                            value: `${APP.appUrl("kraje")}/datasety`
                        }
                    ]
                },
                right: {
                    title: undefined,
                    links: [
                        meta.route
                    ]
                }
            }
        }
    },
    style: {
        width: '80vw',
        height: '100vh',
        maxWidth: '1200px',
    }
}

const votingsPerSittings = {
    title: 'Průměrný počet hlasování na jednom zasedání',
    content: () => {
        return (
            <>
                Počet hlasování na jednom zasedání se může lišit v&nbsp;závislosti na programu a&nbsp;agendě konkrétního zasedání, průměrně dochází ke <span className="emp"><strong>49</strong>&nbsp;hlasováním</span>. Zpravidla se hlasuje o&nbsp;řadě bodů, které zahrnují rozpočtová opatření, schvalování projektů či strategických plánů. Tento průměr poskytuje užitečný přehled o tom, jak intenzivní a náročná zasedání bývají, a&nbsp;může se stát ukazatelem aktivity a&nbsp;efektivity zastupitelstva při řešení regionálních záležitostí.
            </>
        )
    },
    chart: {
        id: "mapa-pocet-hlasovani-zasedani",
        type: "regional-choropleth",
        config: {
            geo: geo,
            data: data,
            categories: meta.pocetHlasovaniNaZasedani.values,
            getValue: meta.pocetHlasovaniNaZasedani.getValue,
            formatValue: meta.pocetHlasovaniNaZasedani.formatValue,
            map: {
                defaults: {
                    polygon: {
                        hoverStyle: {
                            fill: "yellow"
                        },
                        popup: popup
                    },
                    capital: {
                        style: {
                            display: "none"
                        }
                    }
                }
            },
        }
    },
    footer: {
        left: {
            title: {
                label: "Zdroj:",
                icon: "pi pi-fw pi-globe"
            },
            links: [
                {
                    label: "Datové sady",
                    value: `${APP.appUrl("kraje")}/datasety`
                }
            ]
        },
        right: {
            title: undefined,
            links: [
                meta.route
            ]
        },
        popup: {
            component: popup
        }
    }
}
export default votingsPerSittings;